const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCarbonCredit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.48511 2.64486C14.0197 -0.267453 21.0279 0.604409 25.6839 5.26045C31.4119 10.9884 31.4119 20.2738 25.6839 26.0018C25.2438 26.4419 24.7821 26.8486 24.302 27.2204",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31372 4.04883C5.83862 4.41891 5.38019 4.82233 4.94342 5.26076C-0.784526 10.9887 -0.784526 20.2741 4.94342 26.0021C9.59613 30.6548 16.601 31.5283 22.1356 28.6193",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32214 8.07928V4.04004H2.15454",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.302 23.1812V27.2204H28.4696",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2329 16.2128C14.6945 13.6739 16.1498 11.4867 18.0285 10.5065C21.8627 8.50608 26.3637 10.6732 26.3637 10.6732C26.3637 10.6732 25.3268 11.275 24.7934 12.592C24.0166 14.5158 23.4647 17.5131 21.4793 18.4683C19.7722 19.2918 17.5818 19.0818 16.1965 17.8848L15.9414 17.6515",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4634 23.6929C14.4634 21.3057 15.0935 18.9469 16.3622 16.9231C16.9423 15.9979 17.6974 15.061 18.681 14.2058C19.9363 13.1156 21.2883 12.3037 22.4835 11.9253",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7876 14.8512C13.5209 13.7826 12.8174 12.9158 12.0506 12.4623C9.02656 10.6736 5.19238 11.3404 5.19238 11.3404C5.19238 11.3404 5.8592 12.674 6.19261 13.841C6.74606 15.7781 7.12449 17.8619 8.74319 18.6404C10.1352 19.3105 11.9205 19.1405 13.0525 18.1653L13.2475 17.9535",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.464 23.6929V22.9011C14.464 20.954 13.9489 19.0319 12.9153 17.3815C12.4419 16.6263 11.8267 15.8628 11.0249 15.166",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarbonCredit);
export default __webpack_public_path__ + "static/media/icon-carbon-credit.7ee21c0a14b0380572585bb4f56ea4f7.svg";
export { ForwardRef as ReactComponent };